import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Shield, Loader2 } from "lucide-react";
import AdminDashboard from "./AdminDashboard";

const Shell = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
    <div className="max-w-sm w-full text-center rounded-2xl bg-white border border-slate-200 p-8">{children}</div>
  </div>
);

const AdminApp = () => {
  const { user, loading, login, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-500"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  }
  if (!user) {
    return (
      <Shell>
        <Shield className="w-8 h-8 text-sky-600 mx-auto mb-3" />
        <h1 className="text-lg font-bold text-slate-900">Admin area</h1>
        <p className="text-sm text-slate-500 mt-2">Sign in with the admin Google account to continue.</p>
        <Button onClick={login} className="mt-5 w-full bg-sky-600 hover:bg-sky-500 text-white" data-testid="admin-signin">Sign in with Google</Button>
      </Shell>
    );
  }
  if (!user.is_admin) {
    return (
      <Shell>
        <div data-testid="admin-forbidden">
          <Shield className="w-8 h-8 text-rose-600 mx-auto mb-3" />
          <h1 className="text-lg font-bold text-slate-900">Not authorized</h1>
          <p className="text-sm text-slate-500 mt-2">This account ({user.email}) doesn't have admin access.</p>
          <Button onClick={() => navigate("/app")} className="mt-5 w-full bg-sky-600 hover:bg-sky-500 text-white">Go to app</Button>
        </div>
      </Shell>
    );
  }
  return <AdminDashboard onLogout={logout} />;
};

export default AdminApp;
